import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20Card', {
    staticClass: "dt-card-text-01 px-0 mx-0",
    attrs: {
      "buttons": _vm.formCardButtons,
      "offset": 24
    },
    on: {
      "submit-form": function ($event) {
        return _vm.saveDownlinks();
      }
    }
  }, [_c('p', {
    staticClass: "px-4 mt-4"
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.downlinks.subHeaderInfo')) + "\n  ")]), _c(VExpansionPanels, {
    staticClass: "my-4 calculate-elements",
    attrs: {
      "value": 0,
      "flat": ""
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.Configuration')) + "\n        ")])]), _c(VExpansionPanelContent, [!_vm.downlinks || !_vm.downlinks.length ? _c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "align": "right"
    }
  }, [_vm.isIotHubManager ? _c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-plus"
    },
    on: {
      "click": function ($event) {
        return _vm.addNewDownlink(0);
      }
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._l(_vm.downlinks, function (cElement, i) {
    return _c(VRow, {
      key: `c-element-${i}`
    }, [_c(VCol, {
      attrs: {
        "cols": "12",
        "md": "2"
      }
    }, [_c(VTextField, {
      staticClass: "required",
      attrs: {
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": [_vm.requiredRuleCheck(cElement)],
        "disabled": !_vm.isIotHubManager || _vm.formSaving,
        "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.downlinks.name'),
        "hide-details": "auto",
        "autocomplete": "off",
        "required": ""
      },
      on: {
        "keyup": _vm.validate
      },
      model: {
        value: cElement.name,
        callback: function ($$v) {
          _vm.$set(cElement, "name", $$v);
        },
        expression: "cElement.name"
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "12",
        "md": "1"
      }
    }, [_c(VTextField, {
      attrs: {
        "type": "number",
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "disabled": !_vm.isIotHubManager || _vm.formSaving,
        "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.downlinks.port'),
        "hide-details": "auto",
        "autocomplete": "off"
      },
      model: {
        value: cElement.port,
        callback: function ($$v) {
          _vm.$set(cElement, "port", $$v);
        },
        expression: "cElement.port"
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "12",
        "md": "3"
      }
    }, [_c(VTextField, {
      staticClass: "required",
      attrs: {
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": [_vm.requiredRuleCheck(cElement)],
        "disabled": !_vm.isIotHubManager || _vm.formSaving,
        "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.downlinks.payload'),
        "hide-details": "auto",
        "autocomplete": "off",
        "required": ""
      },
      on: {
        "keyup": _vm.validate
      },
      model: {
        value: cElement.payload,
        callback: function ($$v) {
          _vm.$set(cElement, "payload", $$v);
        },
        expression: "cElement.payload"
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "12",
        "md": "2"
      }
    }, [_c(VSelect, {
      staticClass: "required",
      attrs: {
        "items": _vm.encodingTypes,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": [_vm.requiredRuleCheck(cElement)],
        "disabled": !_vm.isIotHubManager || _vm.formSaving,
        "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.downlinks.encoding'),
        "hide-details": "auto"
      },
      model: {
        value: cElement.encoding,
        callback: function ($$v) {
          _vm.$set(cElement, "encoding", $$v);
        },
        expression: "cElement.encoding"
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "12",
        "md": "4"
      }
    }, [_c(VTextField, {
      attrs: {
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "disabled": !_vm.isIotHubManager || _vm.formSaving,
        "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.downlinks.gatewayIds'),
        "hide-details": "auto",
        "autocomplete": "off"
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [_vm.isIotHubManager ? _c('core-button', {
            attrs: {
              "color": _vm.color,
              "prepend-icon": "fa-plus"
            },
            on: {
              "click": function ($event) {
                return _vm.addNewDownlink(i);
              }
            }
          }) : _vm._e(), _vm.isIotHubManager ? _c('core-button', {
            attrs: {
              "color": _vm.color,
              "prepend-icon": "fa-trash-alt"
            },
            on: {
              "click": function ($event) {
                return _vm.removeDownlink(i);
              }
            }
          }) : _vm._e()];
        },
        proxy: true
      }], null, true),
      model: {
        value: cElement.gatewayId,
        callback: function ($$v) {
          _vm.$set(cElement, "gatewayId", typeof $$v === 'string' ? $$v.trim() : $$v);
        },
        expression: "cElement.gatewayId"
      }
    })], 1), _c(VDivider)], 1);
  })], 2)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };